export const STUDY_SUBJECTS = [
  "Histology",
  "Anatomy",
  "Embryology",
  "Physiology",
  "Pathology",
  "Pharmacology",
  "Microbiology",
  "Biochemistry",
  "Immunology",
  "Neuroscience",
  "Histopathology",
  "USMLE",
];

export const SUBJECT_LOOK = {
  Histology: { color: "#2563eb", soft: "#dbeafe" },
  Anatomy: { color: "#0f766e", soft: "#ccfbf1" },
  Embryology: { color: "#db2777", soft: "#fce7f3" },
  Physiology: { color: "#dc2626", soft: "#fee2e2" },
  Pathology: { color: "#7c3aed", soft: "#ede9fe" },
  Pharmacology: { color: "#ea580c", soft: "#ffedd5" },
  Microbiology: { color: "#0891b2", soft: "#cffafe" },
  Biochemistry: { color: "#4f46e5", soft: "#e0e7ff" },
  Immunology: { color: "#059669", soft: "#d1fae5" },
  Neuroscience: { color: "#9333ea", soft: "#f3e8ff" },
  Histopathology: { color: "#b45309", soft: "#fef3c7" },
  USMLE: { color: "#1d4ed8", soft: "#dbeafe" },
};

const STARTERS = {
  Histology: ["Epithelium", "Connective tissue", "Cartilage and bone", "Muscle", "Nerve", "Blood"],
  Anatomy: ["Skeletal system", "Muscular system", "Cardiovascular system", "Respiratory system", "Digestive system", "Nervous system"],
  Embryology: ["Gametogenesis", "First week", "Gastrulation", "Neurulation", "Folding of the embryo", "Fetal membranes"],
  Physiology: ["Membrane transport", "Nerve and muscle", "Circulation", "Respiration", "Renal function", "Endocrine control"],
  Pathology: ["Cell injury", "Inflammation", "Repair", "Neoplasia", "Hemodynamic disorders", "Immunopathology"],
  Pharmacology: ["Pharmacokinetics", "Pharmacodynamics", "Autonomic drugs", "Cardiovascular drugs", "Antimicrobials", "Toxicology"],
  Microbiology: ["Bacteria", "Viruses", "Fungi", "Parasites", "Host defense", "Diagnostic methods"],
  Biochemistry: ["Proteins", "Enzymes", "Carbohydrates", "Lipids", "Nucleic acids", "Metabolism"],
  Immunology: ["Innate immunity", "Antibodies", "T cells", "MHC", "Hypersensitivity", "Vaccines"],
  Neuroscience: ["Neuron structure", "Synaptic transmission", "Spinal cord", "Brainstem", "Cortex", "Sensory pathways"],
  Histopathology: ["Tissue processing", "Staining", "Epithelial lesions", "Inflammatory patterns", "Tumor patterns", "Special stains"],
  USMLE: ["High-yield anatomy", "High-yield histology", "Physiology review", "Pathology patterns", "Pharmacology review", "Practice questions"],
};

export const MATERIAL_LANGUAGES = [
  ["en", "English"],
  ["fr", "French"],
  ["es", "Spanish"],
  ["de", "German"],
  ["pt", "Portuguese"],
  ["pt-br", "Brazilian Portuguese"],
  ["it", "Italian"],
  ["ar", "Arabic"],
  ["fa", "Persian"],
  ["tr", "Turkish"],
  ["ko", "Korean"],
  ["ja", "Japanese"],
  ["zh-cn", "Simplified Chinese"],
  ["hi", "Hindi"],
  ["ru", "Russian"],
];

export function starterTopics(subject) {
  const titles = STARTERS[subject] || ["Core ideas", "Key structures", "How it works", "Practice"];
  return titles.map((title) => ({ title, origin: "starter" }));
}

export function masteryEmoji(value) {
  const score = Number(value);
  if (!Number.isFinite(score)) return "📘";
  if (score >= 85) return "💪";
  if (score >= 60) return "✍️";
  return "👀";
}

export function cleanLessonText(value) {
  return String(value || "")
    .replace(/https?:\/\/\S+/gi, "")
    .replace(/^\s*source\s*:\s*$/gim, "")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
